"use strict";
/**
 * Created by Dale on 20/06/2017.
 */
var toggleClassInTarget = {
    activeClass: 'is-active',
    hasClass: function (el, theClass) {
        return el.classList ?
            el.classList.contains(theClass) :
            new RegExp('(^| )' + theClass + '( |$)', 'gi').test(el.className);
    },
    addActiveClass: function (el, theClass) {
        if (el.classList) {
            el.classList.add(theClass);
        }
        else {
            el.className += ' ' + theClass;
        }
    },
    removeActiveClass: function (el, theClass) {
        if (el.classList) {
            el.classList.remove(theClass);
        }
        else {
            el.className = el.className.replace(new RegExp('(^|\\b)' + theClass.split(' ').join('|') + '(\\b|$)', 'gi'), ' ');
        }
    },
    mainBehaviour: function (cta) {
        var _this = this, ctas = document.querySelectorAll(cta);
        for (var i = 0, len = ctas.length; i < len; i++) {
            ctas[i].addEventListener('click', function () {
                var targetClass = this.getAttribute('data-toggle-class-in');
                var classToToggle = this.getAttribute('data-class-to-toggle');
                var target = document.getElementsByClassName(targetClass)[0];
                if (_this.hasClass(target, classToToggle)) {
                    _this.removeActiveClass(target, classToToggle);
                }
                else {
                    _this.addActiveClass(target, classToToggle);
                }
            });
        }
    }
};
/***
 *   TODO:
 *  Change the timeout below to a more reliable solution
 */
window.addEventListener("load", function () {
    var ctas = document.querySelectorAll("[data-toggle-class-in]");
    if (ctas.length > 0) {
        toggleClassInTarget.mainBehaviour("[data-toggle-class-in]");
    }
});
